import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
/* eslint-disable */
import { saveAs } from 'file-saver';
const ExcelJs = require('exceljs');
export async function exportJsonToExcel(options) {
  // 创建一个工作簿
  const workbook = new ExcelJs.Workbook();
  if (!Array.isArray(options.worksheets)) {
    options.worksheets = [options.worksheets];
  }
  for (let i = 0; i < options.worksheets.length; i++) {
    let sheetOption = options.worksheets[i];
    const sheet = workbook.addWorksheet(sheetOption.sheetName || 'Sheet' + (i + 1));
    sheet.state = sheetOption.state;
    sheet.addRows(sheetOption.data);
    if (sheetOption.merges) {
      sheetOption.merges.forEach(item => {
        sheet.mergeCells(...item);
      });
    }
    if (Array.isArray(sheetOption.dataValidation) && sheetOption.dataValidation.length) {
      sheetOption.dataValidation.forEach(validation => {
        var cellValidation = {
          type: validation.type,
          allBlank: validation.allBlank,
          formulae: validation.formulae,
          operator: validation.operator,
          showInputMessage: validation.showInputMessage,
          promptTitle: validation.promptTitle,
          prompt: validation.prompt,
          errorStyle: validation.errorStyle,
          errorTitle: validation.errorTitle,
          error: validation.error,
          showErrorMessage: validation.showErrorMessage
        };
        var rowStart = validation.rowStart,
          rowEnd = validation.rowEnd || rowStart,
          colStart = validation.colStart,
          colEnd = validation.colEnd || colEnd;
        sheet.eachRow({
          includeEmpty: true
        }, function (row, rowNumber) {
          if (rowNumber >= rowStart && rowNumber <= rowEnd) {
            row.eachCell({
              includeEmpty: true
            }, function (cell, colNumber) {
              if (colNumber >= colStart && colNumber <= colEnd) {
                cell.dataValidation = cellValidation;
              }
            });
          }
        });
      });
    }
    if (sheetOption.protect) {
      const res = await sheet.protect(sheetOption.protect.password, sheetOption.protect.options);
    }
    if (Array.isArray(sheetOption.attrs) && sheetOption.attrs.length) {
      sheetOption.attrs.forEach(item => {
        item.attr = item.attr || {};
        item.method = item.method || {};
        var rowStart = item.rowStart,
          rowEnd = item.rowEnd || rowStart,
          colStart = item.colStart,
          colEnd = item.colEnd || colStart;
        if (rowStart) {
          // 行设置值
          for (let i = rowStart; i <= rowEnd; i++) {
            const row = sheet.getRow(i);
            if (colStart) {
              // 列设置
              for (let c = colStart; c <= colEnd; c++) {
                const cell = row.getCell(c);
                Object.keys(item.attr).forEach(key => {
                  cell[key] = item.attr[key];
                });
                Object.keys(item.method).forEach(m => {
                  cell[m](...item.method[m]);
                });
              }
            } else {
              // 未设置列
              Object.keys(item.attr).forEach(key => {
                row[key] = item.attr[key];
              });
              Object.keys(item.method).forEach(m => {
                row[m](...item.method[m]);
              });
            }
          }
        } else if (colStart) {
          //行未设置,列设置
          for (let c = colStart; c <= colEnd; c++) {
            const column = sheet.getColumn(c);
            Object.keys(item.attr).forEach(key => {
              column[key] = item.attr[key];
            });
            Object.keys(item.method).forEach(m => {
              column[m](...item.method[m]);
            });
          }
        } else {
          // 行和列均未设置，则操作对象未worksheet
          Object.keys(item.attr).forEach(key => {
            sheet[key] = item.attr[key];
          });
          Object.keys(item.method).forEach(m => {
            sheet[m](...item.method[m]);
          });
        }
      });
    }
    if (sheetOption.columnsWidth) {
      for (let i = 0; i < sheet.columns.length; i += 1) {
        sheet.columns[i].width = sheetOption.columnsWidth[i];
      }
    }
  }
  workbook.xlsx.writeBuffer().then(buffer => {
    saveAs(new Blob([buffer], {
      type: 'application/octet-stream'
    }), options.fileName);
  });
}
export function importExcel(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = async e => {
      try {
        const data = e.target.result;
        const workbook = new ExcelJs.Workbook();
        await workbook.xlsx.load(data);
        resolve(workbook);
      } catch (err) {
        reject(err);
      }
    };
    fileReader.readAsBinaryString(file);
  });
}